import { render, staticRenderFns } from "./Pagination.vue?vue&type=template&id=849a166c&"
import script from "./Pagination.vue?vue&type=script&lang=js&"
export * from "./Pagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/iaai/products/maturity-assessment-tool/mat-website/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('849a166c')) {
      api.createRecord('849a166c', component.options)
    } else {
      api.reload('849a166c', component.options)
    }
    module.hot.accept("./Pagination.vue?vue&type=template&id=849a166c&", function () {
      api.rerender('849a166c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Pagination.vue"
export default component.exports